// extracted by mini-css-extract-plugin
module.exports = {"container":"CaseStudies_container__YwetV","logo":"CaseStudies_logo__Hvj4_","filter":"CaseStudies_filter___2_If","cta":"CaseStudies_cta__OZHqT"};